import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { ElectricityMixUsage } from '@/features/Sustainability/components/ElectricityMixUsage/ElectricityMixUsage'

export const Route = createFileRoute(
    '/_layout/sustainability/electricity-mix-usage'
)({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <ElectricityMixUsage />
            </RoleRestrictedContent>
        </>
    )
}
